module.exports = __webpack_public_path__ + "img/rick-morty.f2ae8ffd.png";